import firebase from "./firebase-config";
export const googleProvider = new firebase.auth.GoogleAuthProvider();
